import React, { useState, useEffect } from "react";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { useNavigate } from "react-router-dom";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import { Modal, Button, Table } from "react-bootstrap";
import { FaSpinner } from "react-icons/fa";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { useDispatch } from "react-redux";
import moment from "moment";

const AllProjects = () => {
  const [loading, setLoading] = useState(true);
  const [apiStatus, setApiStatus] = useState(undefined);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateNavbarHeading("All Projects"));
  }, []);

  const columns = {
    ProjectName: {
      text: "Project",
      align: "start",
      type: "Modal",
      visible: true,
    },
    ClientName: { text: "Client", width: "100px", align: "start", visible: true },
    ProjectType: { text: "Project Type", align: "start", visible: true },
    Location: { text: "Location", align: "start", visible: true },
    StartDate: { text: "Start Date", align: "center", visible: true },
    EndDate: { text: "End Date", align: "center", visible: true },
    ContractStatus: {
      text: "Contract Status",
      align: "center",
      // width: "400px",
      visible: true,
    },
  };

  const [projectOptions, setProjectOptions] = useState([]);
  const [projectLocationOptions, setProjectLocationOptions] = useState([]);
  const [clientOptions, setClientOptions] = useState([]);

  useEffect(() => {
    fetchAllProjects();
  }, []);

  const fetchAllProjects = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}all-project?ClientID=${
          filterFormData.find((o) => o.label === "Client")
            ? filterFormData.find((o) => o.label === "Client").value
            : 0
        }&ProjectID=${
          filterFormData.find((o) => o.label === "Project")
            ? filterFormData.find((o) => o.label === "Project").value
            : 0
        }&ProjectType=${
          filterFormData.find((o) => o.label === "Project Type")
            ? filterFormData.find((o) => o.label === "Project Type").value
            : 0
        }`
      );
      if (response.status === 200) {
        setApiStatus(response?.status);
        const cleanedData = response.data.headers;

        setAllProjectsList(cleanedData);

        const project = response.data.project.map((ele) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setProjectOptions(project);
        const projectallocationtype = response.data.projectallocationtype.map(
          (ele) => ({
            value: ele?.value,
            label: ele?.text,
          })
        );
        setProjectLocationOptions(projectallocationtype);
        const client = response.data.client.map((ele) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setClientOptions(client);

        setLoading(false);
      } else {
        console.error(
          "Failed to fetch partnerMaster. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      setApiStatus('')
      console.error("Error fetching PartnerMaster:", error);
    }
  };

  const [allProjectsList, setAllProjectsList] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");

  const formDatas = [
    {
      name: "Client",
      type: "Select",
      options: [...clientOptions],
    },
    {
      name: "Project",
      type: "Select",
      options: [...projectOptions],
    },
    {
      name: "Project Type",
      type: "Select",
      options: [...projectLocationOptions],
    },
  ];
  const [filterFormData, setFilterData] = useState([]);

  const handleChange = (e, name) => {
    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };

  const handleGetData = () => {
    fetchAllProjects();
  };

  const [showModal, SetShowModal] = useState(false);
  const [selectedModalItem, setSelectedModalItem] = useState([]);

  const handleModalColumn = (columnName, item) => {
    SetShowModal(true);
    setSelectedModalItem(item);
    fetchResource(item.ID);
  };

  const [modalResourceData, setModalResourceData] = useState([]);
  const [modalDeatilsData, setModalDeatilsData] = useState([]);
  console.log("modalResourceData", modalResourceData);

  const fetchResource = async (id) => {
    try {
      let response;
      response = await GetServiceCaller(`${API_URL}projectdetails/${id}
 `);

      if (response?.status === 200) {
        setModalResourceData(response?.data?.projectmember);
        setModalDeatilsData(response?.data?.projectdetails[0]);
        console.log("response?.data?.data", response?.data);
      }
    } catch (error) {
      console.error("FEtching Resource Error ", error);
    }
  };
  const handleModalClose = () => {
    SetShowModal(false);
  };


  const handleReset = () => {
    setFilterData([]);
  };
  

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={allProjectsList}
              columns={columns}
              itemsPerPage={10}
              handleReset={handleReset}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              showIcon1={true}
              showIcon2={false}
              isSorting={true}
              isFilterRequired={true}
              isRequiredStatus={true}
              isApiStatus={apiStatus}
              formDatas={formDatas}
              filterFormData={filterFormData}
              isActionRequired={false}
              isAddNewBtnRequired={false}
              handleGetData={handleGetData}
              handleModalColumn={handleModalColumn}
              showIcon3={false}
              showIcon4={true}
              showIcon5={false}
              handleChange={handleChange}
              // handleIcon1={handleEdit}
              // handleAddNew={handleAddNewPartner}
              // handleIcon4={handleAddSubContractor}
              add
              more
              function
              icons={{
                Icon1: <i class="bi bi-pencil-square icons"></i>,
                Icon1Text: " Edit",
                Icon2: <i class="bi bi-trash-fill icons"></i>,
                Icon3: <i class="bi bi-eye-fill icons"></i>,
                Icon4: <i class="bi bi-plus-square icons"></i>,
                Icon4Text: " Add Sub-contractor",
              }}
            />
          </div>
        </div>
      </div>

      {/* <Modal
        show={showModal}
        onHide={handleModalClose}
        dialogClassName="modal-xl"
      >
        <div
          style={{ backgroundColor: "#F2F2F4" }}
          className="card rounded border-0 m-2"
        >
          <Modal.Header scloseButton>
            <Modal.Title className="text-info">
              <div className="text-center d-flex justify-center">
                <p style={{
        fontSize: '20px',
        fontWeight: '600',
        color: '#27568B',
        margin: '0'
      }}>
                  Project Details
                </p>
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              className="rounded m-3 px-4 align-middle"
              style={{
                maxHeight: "60vh",
                overflow: "scroll",
                backgroundColor: "white",
              }}
            >
              <div className="row mt-1">
                <div className="col-6 d-flex">
                  <div className="col-3 fw-bold">Client</div>
                  <div className="col-3">{modalDeatilsData?.ClientName}</div>
                </div>
                <div className="col-6 d-flex">
                  <div className="col-3 fw-bold">Project Name</div>
                  <div className="col-3">{selectedModalItem?.ProjectName}</div>
                </div>
              </div>
              <div className="row  mt-3">
                <div className="col-6 d-flex">
                  <div className="col-3 fw-bold">Start Date</div>
                  <div className="col-3">
                    {selectedModalItem?.StartDate
                      ? moment(selectedModalItem?.StartDate).format(
                          "DD-MMM-YYYY"
                        )
                      : null}
                  </div>
                </div>
                <div className="col-6 d-flex">
                  <div className="col-3 fw-bold">End Date</div>
                  <div className="col-3">
                    {selectedModalItem?.EndDate
                      ? moment(selectedModalItem?.EndDate).format("DD-MMM-YYYY")
                      : null}
                  </div>
                </div>
              </div>
            </div>
            <div
              className="rounded m-3 mt-4 px-4 align-middle"
              style={{
                maxHeight: "60vh",
                overflow: "scroll",
                backgroundColor: "white",
              }}
            >
              <div className="row mt-1">
                <h4>
                  <i class="bi bi-people-fill icons me-2"></i>
                  Resources
                </h4>
              </div>
             {[1136, 6958, 6905].includes(modalDeatilsData?.ProjectAllocationType_160) ?
( <Table striped hover bordered>
                <thead id="thcolor">
                  <tr className="align-middle text-center">
                    <th>Sr. No.</th>
                    <th>Employee</th>
                    <th>Course</th>
                    <th className="px-0">Version/Mode/Type</th>
                    <th className="px-0">Time Zone/From Time/To Time</th>
                    <th className="px-0">Start Date/End Date</th>
                    <th className="px-0">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {modalResourceData?.length ? (
                    modalResourceData.map((ele, index) => (
                      <tr key={`resource-${index}`}>
                        <td className="text-center">{index + 1}</td>
                        <td>{ele?.EmployeeName || "-"}</td>
                        <td>{ele?.CourseName || "-"}</td>
                        <td>
                          {[
                            ele?.DeliveryVersion,
                            ele?.DeliveryMode,
                            ele?.TrainingType,
                          ]
                            .filter(Boolean)
                            .join(" / ") || "-"}
                        </td>
                        <td>
                          {[ele?.TimeZone, ele?.FromTime, ele?.ToTime]
                            .filter(Boolean)
                            .join(" / ") || "-"}
                        </td>
                        <td>
                          {ele?.FromDate && ele?.ToDate
                            ? `${moment(ele.FromDate).format(
                                "DD-MMM-YYYY"
                              )} / ${moment(ele.ToDate).format("DD-MMM-YYYY")}`
                            : "-"}
                        </td>
                        <td className="text-center">
                          <i
                            className="bi bi-pencil-square cursor-pointer disabled-icon"
                            //   onClick={() => handleEdit(ele)}
                          ></i>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center text-muted py-3">
                        No Data Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>)
:(
             
              <Table striped hover bordered>
                <thead id="thcolor">
                  <tr className="align-middle text-center">
                    <th>Sr. No.</th>
                    <th>Employee</th>
                    <th>Role</th>
                    <th className="px-0">
                      <div className="border-1 border-bottom">Location</div>
                      <div>Loc. Type </div>
                    </th>
                    <th className="px-0">
                      <div className="border-1 border-bottom">From Date</div>
                      <div>To Date</div>
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {modalResourceData?.length ? (
                    modalResourceData.map((ele, index) => (
                      <tr key={`resource-${index}`}>
                        <td className="text-center">{index + 1}</td>
                        <td className="text-center">{ele?.EmployeeName || "-"}</td>
                        <td className="text-center">{ele?.Role || "-"}</td>
                        <td >
                        <div className="border-1 border-bottom text-center">  {
                            ele?.LocationName}</div>
                        <div className="text-center">  {
                            ele?.LocationType}</div>
                        </td>
                        <td>
                        <div className="border-1 border-bottom text-center">  {
                          ele?.FromDate?moment( ele?.FromDate).format("DD-MMM-YYYY"):'-'}</div>
                        <div className="text-center">  {
                            ele?.ToDate?moment( ele?.ToDate).format("DD-MMM-YYYY"):'-'}</div>
                        </td>
                    
                        <td className="text-center">
                          <i
                            className="bi bi-pencil-square cursor-pointer disabled-icon"
                            //   onClick={() => handleEdit(ele)}
                          ></i>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center text-muted py-3">
                        No Data Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>)}
            </div>
          </Modal.Body>
          <Modal.Footer>
                        <Button className="custom-btn" onClick={handleModalClose}>
                            Cancel
                        </Button>
                        <Button
                            disabled={loading ? true : false}
                            className="custom-btn "
                        //   onClick={handleSendJDMail}
                        >
                            {loading ? <FaSpinner class="sm-spinner" /> : "Send Mail"}
                        </Button>
                    </Modal.Footer> 
        </div>
      </Modal> */}
      <Modal
  show={showModal}
  onHide={handleModalClose}
  dialogClassName="modal-xl"
  centered
>
  <div className="modal-content" style={{ borderRadius: '8px', border: 'none' }}>
    <div 
      className="modal-header" 
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '1px solid #f0f0f0',
        backgroundColor: '#f8f9fa',
        borderRadius: '8px 8px 0 0',
        padding: '16px'
      }}
    >
      <p style={{
        fontSize: '18px',
        fontWeight: '600',
        color: '#27568B',
        margin: '0'
      }}>
        Project Details
      </p>
      <button 
        onClick={handleModalClose}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          fontSize: '18px',
          color: '#000',
          padding: '4px',
          borderRadius: '4px',
          transition: 'all 0.2s',
          lineHeight: '1'
        }}
      >
        <i className="bi bi-x-lg"></i>
      </button>
    </div>
    
    <Modal.Body style={{ padding: '16px' }}>
      {/* Project Info Section */}
      <div 
        className="rounded p-3 mb-4" 
        style={{
          backgroundColor: 'white',
          boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
          border: '1px solid #e9ecef'
        }}
      >
        <div className="row">
          <div className="col-md-6 mb-3">
            <div className="d-flex">
              <div style={{ width: '120px', fontWeight: '600', color: '#495057' }}>Client</div>
              <div style={{ color: '#212529' }}>{modalDeatilsData?.ClientName || '-'}</div>
            </div>
          </div>
          <div className="col-md-6 mb-3">
            <div className="d-flex">
              <div style={{ width: '120px', fontWeight: '600', color: '#495057' }}>Project Name</div>
              <div style={{ color: '#212529' }}>{selectedModalItem?.ProjectName || '-'}</div>
            </div>
          </div>
        </div>
        
        <div className="row">
          <div className="col-md-6 mb-3">
            <div className="d-flex">
              <div style={{ width: '120px', fontWeight: '600', color: '#495057' }}>Start Date</div>
              <div style={{ color: '#212529' }}>
                {selectedModalItem?.StartDate
                  ? moment(selectedModalItem?.StartDate).format("DD-MMM-YYYY")
                  : '-'}
              </div>
            </div>
          </div>
          <div className="col-md-6 mb-3">
            <div className="d-flex">
              <div style={{ width: '120px', fontWeight: '600', color: '#495057' }}>End Date</div>
              <div style={{ color: '#212529' }}>
                {selectedModalItem?.EndDate
                  ? moment(selectedModalItem?.EndDate).format("DD-MMM-YYYY")
                  : '-'}
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Resources Section */}
      <div 
        className="rounded p-1" 
        style={{
          backgroundColor: 'white',
          boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
          border: '1px solid #e9ecef'
        }}
      >
        <div className="d-flex align-items-center mb-1">
          <i className="bi bi-people-fill me-2" style={{ color: '#27568B', fontSize: '20px' }}></i>
          <h4 style={{ margin: '0', color: '#27568B', fontSize: '18px' }}>Resources</h4>
        </div>
        
        {[1136, 6958, 6905].includes(modalDeatilsData?.ProjectAllocationType_160) ? (
          <div className="table-responsive">
            <table className="table table-hover table-bordered" style={{ marginBottom: '0' }}>
              <thead id="thcolor" className="text-center">
                <tr>
                  <th style={{ width: '5%'}}>Sr. No.</th>
                  <th style={{ width: '20%' }}>Employee</th>
                  <th style={{ width: '15%' }}>Course</th>
                  <th style={{ width: '20%' }}>Version/Mode/Type</th>
                  <th style={{ width: '20%' }}>Time Zone/From Time/To Time</th>
                  <th style={{ width: '15%' }}>Start Date/End Date</th>
                  <th style={{ width: '5%'}}>Action</th>
                </tr>
              </thead>
              <tbody>
                {modalResourceData?.length ? (
                  modalResourceData.map((ele, index) => (
                    <tr key={`resource-${index}`}>
                      <td style={{ textAlign: 'center' }}>{index + 1}</td>
                      <td>{ele?.EmployeeName || "-"}</td>
                      <td>{ele?.CourseName || "-"}</td>
                      <td>
                        {[
                          ele?.DeliveryVersion,
                          ele?.DeliveryMode,
                          ele?.TrainingType,
                        ]
                          .filter(Boolean)
                          .join(" / ") || "-"}
                      </td>
                      <td>
                        {[ele?.TimeZone, ele?.FromTime, ele?.ToTime]
                          .filter(Boolean)
                          .join(" / ") || "-"}
                      </td>
                      <td>
                        {ele?.FromDate && ele?.ToDate
                          ? `${moment(ele.FromDate).format(
                              "DD-MMM-YYYY"
                            )} / ${moment(ele.ToDate).format("DD-MMM-YYYY")}`
                          : "-"}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        <i
                          className="bi bi-pencil-square cursor-pointer disabled-icon"
                          style={{ color: '#6c757d' }}
                        ></i>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" style={{ textAlign: 'center', color: '#6c757d', padding: '16px' }}>
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="table-responsive">
            <table className="table table-hover table-bordered" style={{ marginBottom: '0' }}>
              <thead id="thcolor">
                <tr>
                  <th style={{ width: '5%', textAlign: 'center' }}>Sr. No.</th>
                  <th style={{ width: '20%', textAlign: 'center' }}>Employee</th>
                  <th style={{ width: '15%', textAlign: 'center' }}>Role</th>
                  <th style={{ width: '20%', textAlign: 'center' }}>
                    <div className="border-bottom pb-1">Location</div>
                    <div className="pt-1">Loc. Type</div>
                  </th>
                  <th style={{ width: '20%', textAlign: 'center' }}>
                    <div className="border-bottom pb-1">From Date</div>
                    <div className="pt-1">To Date</div>
                  </th>
                  <th style={{ width: '5%', textAlign: 'center' }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {modalResourceData?.length ? (
                  modalResourceData.map((ele, index) => (
                    <tr key={`resource-${index}`}>
                      <td style={{ textAlign: 'center' }}>{index + 1}</td>
                      <td style={{ textAlign: 'center' }}>{ele?.EmployeeName || "-"}</td>
                      <td style={{ textAlign: 'center' }}>{ele?.Role || "-"}</td>
                      <td style={{ textAlign: 'center' }}>
                        <div className="border-bottom pb-1">{ele?.LocationName || '-'}</div>
                        <div className="pt-1">{ele?.LocationType || '-'}</div>
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        <div className="border-bottom pb-1">
                          {ele?.FromDate ? moment(ele?.FromDate).format("DD-MMM-YYYY") : '-'}
                        </div>
                        <div className="pt-1">
                          {ele?.ToDate ? moment(ele?.ToDate).format("DD-MMM-YYYY") : '-'}
                        </div>
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        <i
                          className="bi bi-pencil-square cursor-pointer disabled-icon"
                          style={{ color: '#6c757d' }}
                        ></i>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" style={{ textAlign: 'center', color: '#6c757d', padding: '16px' }}>
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </Modal.Body>
  </div>
</Modal>
    </>
  );
};

export default AllProjects;
